<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <template v-if="base">
      <List v-show="list" ref="list" />
      <Detail v-if="detail" @refresh="refresh" />
    </template>
  </div>
</template>

<script>

import List from './Result.List';

export default {
  components: { List },
  data: () => ({ base: false, list: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = false); }
      else { this.detail = !(this.list = false); }
    }
  },
  created: function() { console.log('result.vue', 'created'); },
  destroyed: function() { console.log('result.vue', 'destroyed'); },
  mounted: function() { console.log('result.vue', 'mounted'); this.select(this.$route.params); },
  watch: {
    '$route' (to, from) {
      console.log('result.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
</script>
